import { Component } from "@angular/core";

import { SvgMixinLargeComponent } from "../svg-large-mixin.component";

@Component({
  selector: "med-icon-forward-large",
  templateUrl: "./med-icon-forward-large.component.html",
})
export class MedIconForwardLargeComponent extends SvgMixinLargeComponent { }
